<template>
  <page-container>
      <h3>Welcome to Hello PO!</h3>
      <hr>
      <p>
          <a href="/">Hello PO</a> is a community-run organization which aims to gather and provide information to Pacifica
          Online players.
      </p>
      <p>
          We are not affiliated with the makers of Pacifica Online.
          <br>
          Avoid entertaining people claiming to be one of us who asks for your password.
      </p>
      <h4 class="mt-5">Contributors</h4>
      <contributors></contributors>


  </page-container>
</template>

<script>

  import skills from '../assets/skills'

export default {
  name: 'Home',
}
</script>
